import { useMutation } from 'react-query';
import { linkSsoSignInToUser } from 'shared/services/ogp-sign-in-sso/link-sso-sign-in-to-user.service';

export const useLinkSsoIdToUser = () => {
  const mutationFn = async ({
    email,
    awsIdentityProviderToken,
  }: {
    email: string;
    awsIdentityProviderToken: string;
  }) => {
    await linkSsoSignInToUser(email, awsIdentityProviderToken);
  };
  const { mutate: linkSsoIdToUser } = useMutation(mutationFn);

  return linkSsoIdToUser;
};
